export {
  IFontFace,
  IFontWeight,
  IRawStyle,
  IStyle,
  IStyleSet,
  IProcessedStyleSet,
  IStyleSheetConfig,
  ICSPSettings,
  InjectionMode,
  Stylesheet,
  concatStyleSets,
  concatStyleSetsWithProps,
  fontFace,
  keyframes,
  mergeStyleSets,
  mergeStyles,
} from '@fluentui/merge-styles';
